/* 
  Enriched Mock Data for CookCircuit
  Includes expanded recipes, pantry items, and demo workflow steps.
*/

export const recipes = [
  {
    id: 1,
    title: 'Circuit-Seared Salmon',
    time: '25m',
    prep: '10m',
    cook: '15m',
    cals: '450',
    macros: { p: '35g', c: '5g', f: '28g' },
    tags: ['High Protein', 'Oven', 'Quick'],
    image: 'https://images.unsplash.com/photo-1485921325833-c519f76c4927?auto=format&fit=crop&q=80&w=800',
    appliance: 'Smart Oven',
    temp: '400°F',
    difficulty: 'Medium',
    servings: 2,
    ingredients: ['Salmon Fillet', 'Lemon', 'Asparagus', 'Olive Oil']
  },
  {
    id: 2,
    title: 'Modular Quinoa Bowl',
    time: '15m',
    prep: '15m',
    cook: '0m',
    cals: '380',
    macros: { p: '14g', c: '45g', f: '12g' },
    tags: ['Vegan', 'Prep', 'Cold'],
    image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&q=80&w=800',
    appliance: 'None',
    temp: '--',
    difficulty: 'Easy',
    servings: 1,
    ingredients: ['Quinoa', 'Cucumber', 'Cherry Tomatoes', 'Chickpeas']
  },
  {
    id: 3,
    title: 'Kinetic Beef Stir-fry',
    time: '20m',
    prep: '10m',
    cook: '10m',
    cals: '520',
    macros: { p: '40g', c: '30g', f: '22g' },
    tags: ['High Protein', 'Stove', 'Spicy'],
    image: 'https://images.unsplash.com/photo-1603133872878-684f208fb84b?auto=format&fit=crop&q=80&w=800',
    appliance: 'Induction Hob',
    temp: 'High',
    difficulty: 'Medium',
    servings: 4,
    ingredients: ['Beef Strips', 'Broccoli', 'Soy Sauce', 'Ginger']
  },
  {
    id: 4,
    title: 'Overnight Oat Matrix',
    time: '5m',
    prep: '5m',
    cook: '0m',
    cals: '310',
    macros: { p: '10g', c: '48g', f: '8g' },
    tags: ['Breakfast', 'Prep', 'Vegetarian'],
    image: 'https://images.unsplash.com/photo-1517673132405-a56a62b18caf?auto=format&fit=crop&q=80&w=800',
    appliance: 'Fridge',
    temp: '38°F',
    difficulty: 'Easy',
    servings: 1,
    ingredients: ['Oats', 'Chia Seeds', 'Blueberries', 'Honey']
  },
  {
    id: 5,
    title: 'Thermal Roasted Roots',
    time: '45m',
    prep: '10m',
    cook: '35m',
    cals: '290',
    macros: { p: '6g', c: '42g', f: '14g' },
    tags: ['Vegan', 'Oven', 'Side'],
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&q=80&w=800',
    appliance: 'Smart Oven',
    temp: '425°F',
    difficulty: 'Easy',
    servings: 4,
    ingredients: ['Carrots', 'Potatoes', 'Rosemary', 'Garlic']
  }
];

export const pantryItems = [
  { id: 1, name: 'Jasmine Rice', category: 'Grains', stock: 85, unit: '%', status: 'Optimal' },
  { id: 2, name: 'Olive Oil', category: 'Liquids', stock: 15, unit: '%', status: 'Low' },
  { id: 3, name: 'Chicken Breast', category: 'Proteins', stock: 0, unit: 'lbs', status: 'Empty' },
  { id: 4, name: 'Avocado', category: 'Produce', stock: 2, unit: 'pcs', status: 'Optimal' },
  { id: 5, name: 'Almond Milk', category: 'Dairy/Alt', stock: 60, unit: '%', status: 'Optimal' },
  { id: 6, name: 'Black Beans', category: 'Canned', stock: 5, unit: 'cans', status: 'Optimal' },
];

export const demoSteps = [
  {
    id: 1,
    title: "Inventory Sync",
    desc: "The system scans your smart pantry and detects available ingredients for the week.",
    action: "Run Visual Scan",
    icon: "FiBox"
  },
  {
    id: 2,
    title: "Logic Mapping",
    desc: "AI filters recipes based on your household's dietary goals and appliance availability.",
    action: "Configure Filters",
    icon: "FiSliders"
  },
  {
    id: 3,
    title: "Circuit Generation",
    desc: "A modular meal board is generated, grouping prep tasks to save up to 4 hours weekly.",
    action: "Build Board",
    icon: "FiGrid"
  },
  {
    id: 4,
    title: "Procurement",
    desc: "Missing ingredients are automatically batched into an optimized shopping list.",
    action: "Review Cart",
    icon: "FiCheckCircle"
  },
  {
    id: 5,
    title: "Live Execution",
    desc: "Step-by-step prep timers sync directly with your connected kitchen appliances.",
    action: "Start Prep",
    icon: "FiPlayCircle"
  }
];

export const weeklyPlan = {
  Mon: { dinner: recipes[0] },
  Tue: { lunch: recipes[1], dinner: recipes[2] },
  Wed: { breakfast: recipes[3], dinner: recipes[4] },
  Thu: { dinner: recipes[0] },
  Fri: { lunch: recipes[2] },
  Sat: { dinner: recipes[4] },
  Sun: { breakfast: recipes[3], dinner: recipes[2] }
};